import { SummaryItem } from '../SummaryItem';
import { SummaryStatus } from '../SummaryStatus';

import type { TypeStatusCount } from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyDeliveryStatusDeliveryIssue.module.scss';

interface DeliveryAgencyDeliveryStatusDeliveryIssueProps {
  deliveryCanceled?: TypeStatusCount;
  notInNmPickUpOffice?: TypeStatusCount;
  deliveryDelayed?: TypeStatusCount;
}

const DeliveryAgencyDeliveryStatusDeliveryIssue = ({
  deliveryCanceled,
  notInNmPickUpOffice,
  deliveryDelayed,
}: DeliveryAgencyDeliveryStatusDeliveryIssueProps) => {
  return (
    <div className={styles.container}>
      <SummaryItem title="배송 취소">
        <SummaryStatus total={deliveryCanceled?.total ?? 0} current={deliveryCanceled?.count ?? 0} color="#E54445" />
      </SummaryItem>
      <SummaryItem title="Hub 미입고">
        <SummaryStatus
          total={notInNmPickUpOffice?.total ?? 0}
          current={notInNmPickUpOffice?.count ?? 0}
          color="#E54445"
        />
      </SummaryItem>
      <SummaryItem title="지연배송(확정)">
        <SummaryStatus total={deliveryDelayed?.total ?? 0} current={deliveryDelayed?.count ?? 0} color="#F1C236" />
      </SummaryItem>
    </div>
  );
};

export { DeliveryAgencyDeliveryStatusDeliveryIssue };
